import React from "react";
import cn from "classnames";
import "./style.less";
import PrimaryButtonFullWidth from "components/Design/Button/PrimaryButtonFullWidth";
import ConditionalLink from "components/ConditionalLink";

export const CardValidity = ({
  title,
  className,
  children,
  ctaUrl,
  ctaLabel,
  handleInvalidSearch,
}) => {
  return (
    <div className={cn("w-full bg-white", { [className]: className })}>
      <div className="py-6 mb-20 border-b border-gray-light">
        <p className="font-mulish text-gold font-semibold text-12 tracking-16 uppercase">
          {title}
        </p>
      </div>
      <div>{children}</div>
      {ctaUrl && ctaLabel && (
        <div class="w-full mx-auto text-12-22 mt-20">
          <ConditionalLink link={ctaUrl} sameTab>
            <PrimaryButtonFullWidth
              label={ctaLabel}
              onClick={handleInvalidSearch}
            />
          </ConditionalLink>
        </div>
      )}
    </div>
  );
};
